// TradeToolbar.tsx
import * as React from "react";
import { Box, Button } from "@chakra-ui/react";
import { FiRefreshCw } from "react-icons/fi";
import { IoFilter } from "react-icons/io5";
// import { PiExport } from "react-icons/pi";

type Props = {
  onToggleFilters?: () => void;
  onRefresh?: () => void | Promise<void>;
  onExport?: () => void;
  onNewTrade?: () => void;
  isLoading?: boolean;
};

const Toolbar: React.FC<Props> = ({
  onToggleFilters = () => {},
  onRefresh = () => {},
  onExport = () => {},
  onNewTrade = () => {},
  isLoading = false,
}) => {
  return (
    <div className="mb-3 flex items-center justify-between">
      <h3 className="text-xl font-semibold text-navy-700 dark:text-white">
        Batches
      </h3>
      <Box className="flex items-center justify-end gap-3">
        <Button
          variant="outline"
          onClick={onToggleFilters}
          className="h-9 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
          leftIcon={<IoFilter size={16} />}
        >
          Filters
        </Button>
        <Button
          variant="outline"
          onClick={onRefresh}
          isDisabled={isLoading}
          className="h-9 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
          leftIcon={<FiRefreshCw size={16} />}
        >
          Refresh
        </Button>
      </Box>
    </div>
  );
};

export default Toolbar;
